import { z } from 'zod';

export const PointSchema = z.object({
  x: z.number().nullable().default(null),
  y: z.number().nullable().default(null),
})

export type Point = z.infer<typeof PointSchema>;
